import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=5c80ecba&scoped=true&"
import script from "./FolderIcon.vue?vue&type=script&lang=js&"
export * from "./FolderIcon.vue?vue&type=script&lang=js&"
import style0 from "./FolderIcon.vue?vue&type=style&index=0&id=5c80ecba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80ecba",
  null
  
)

export default component.exports